import React, {useEffect} from "react";
import notfoundimage from "../assets/images/notfound.png";
import IconButton from "../components/molecules/IconButton";
import { analytics } from "../firebase.config";

function NotFound(props) {

  useEffect(() => {
    analytics.logEvent(`Page_NotFound`, {
      item: props.match.url
    });
  });

  return (
    <div className={"notfound"}>
      <img
        className={"notfound__image"}
        src={notfoundimage}
        alt={"No hay mascotas aqui"}
      />
      <div className={"notfound__information"}>
        <h1 className={"notfound__title"}>¿Te encuentras perdido?</h1>
        <p className={"notfound__text"}>No te preocupes. Nosotros te ayudaremos a regresar.</p>
      </div>
      <div className={"notfound__button"}>
        <IconButton goTo={"/"} buttonText={"Presiona aquí"} />
      </div>
    </div>
  );
}

export default NotFound;
